import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-045ee992"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "social-graph-sidebar"
}
const _hoisted_2 = { class: "social-graph-info" }
const _hoisted_3 = { class: "social-graph-survey-title" }
const _hoisted_4 = { class: "social-graph-date" }
const _hoisted_5 = { class: "social-graph-aggregates" }
const _hoisted_6 = { class: "metric" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "SENT", -1))
const _hoisted_8 = { class: "metric" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "VIEWED", -1))
const _hoisted_10 = { class: "metric" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "COMPLETED", -1))
const _hoisted_12 = { class: "social-graph-options" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View By:", -1))
const _hoisted_15 = {
  key: 1,
  class: "social-graph-share-options"
}
const _hoisted_16 = { for: "shareable" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "sharable-label",
  style: {"margin-right":"0.2rem"}
}, "Allow Sharing:", -1))
const _hoisted_18 = { for: "share-options" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Contact Visibility:", -1))
const _hoisted_20 = { for: "share-link" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Share Link:", -1))
const _hoisted_22 = {
  key: 0,
  class: "social-graph-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_switch = _resolveComponent("n-switch")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_copy_icon = _resolveComponent("copy-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_back_icon = _resolveComponent("back-icon")!
  const _component_ExportCSVModal = _resolveComponent("ExportCSVModal")!
  const _component_ConfirmShareableChangeModal = _resolveComponent("ConfirmShareableChangeModal")!
  const _component_ConfirmHideContactsChangeModal = _resolveComponent("ConfirmHideContactsChangeModal")!

  return (_ctx.surveyRef)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.surveyRef?.name), 1),
          _createElementVNode("time", _hoisted_4, "Created: " + _toDisplayString(_ctx.formatDate(_ctx.surveyRef?.createdOn ?? '')), 1),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.surveyRef?.sentCount.toLocaleString()), 1),
              _hoisted_7
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.surveyRef?.viewCount.toLocaleString()), 1),
              _hoisted_9
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.surveyRef?.completedCount.toLocaleString()), 1),
              _hoisted_11
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.showViewOptions)
            ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_n_select, {
                  options: _ctx.viewOptions,
                  value: _ctx.selectedViewOption,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedViewOption) = $event)),
                  style: {"font-weight":"normal"}
                }, null, 8, ["options", "value"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isPublicValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_n_switch, {
                    "aria-labelledby": "sharable-label",
                    name: "shareable",
                    value: _ctx.isShareable,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShareable) = $event)),
                    onChange: _ctx.toggleShareableChangeModal,
                    "aria-label": "Toggle sharing"
                  }, null, 8, ["value", "onChange"])
                ]),
                (_ctx.isShareableConfirmed)
                  ? (_openBlock(), _createBlock(_component_n_space, {
                      key: 0,
                      style: {"display":"flex","flex-direction":"column"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_n_select, {
                            name: "share-options",
                            options: _ctx.shareOptions,
                            value: _ctx.hideContacts,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hideContacts) = $event)),
                            style: {"font-weight":"normal"},
                            onChange: _ctx.toggleHideContactsChangeModal
                          }, null, 8, ["options", "value", "onChange"])
                        ]),
                        _createElementVNode("label", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_n_input, {
                            name: "share-link",
                            readonly: "",
                            value: _ctx.shareLink,
                            type: "textarea",
                            class: "social-graph-share-link"
                          }, null, 8, ["value"])
                        ]),
                        _createVNode(_component_n_button, {
                          onClick: _ctx.copyShareLinkToClipboard,
                          type: "tertiary",
                          style: {"margin-top":"0.3rem","margin-bottom":"0.3rem"},
                          "aria-label": "Copy share link"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, {
                              size: "17",
                              class: "copy-icon",
                              "aria-hidden": "true"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_copy_icon)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" Copy ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isPublicValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_n_button, {
                class: "action",
                onClick: _ctx.navigateToDataCleanup,
                disabled: _ctx.surveyRef?.completedCount === 0,
                "aria-disabled": _ctx.surveyRef?.completedCount === 0,
                hidden: !_ctx.isAdmin
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Data Cleanup")
                ]),
                _: 1
              }, 8, ["onClick", "disabled", "aria-disabled", "hidden"]),
              _createVNode(_component_n_button, {
                disabled: !_ctx.surveyRef?.recipientCount && !_ctx.surveyRef?.sentCount,
                class: "action",
                onClick: _ctx.navigateToParticipants
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Participants")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_n_button, {
                class: "action",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showExportModal = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Export Data (CSV)")
                ]),
                _: 1
              }),
              _createVNode(_component_n_button, {
                class: "action",
                type: "primary",
                onClick: _ctx.navigateToList
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_icon, {
                    size: "17",
                    class: "back-icon",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_back_icon)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Survey List ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isPublicValue)
          ? (_openBlock(), _createBlock(_component_ExportCSVModal, {
              key: 1,
              survey: _ctx.surveyRef,
              showModal: _ctx.showExportModal,
              "onUpdate:showModal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showExportModal) = $event))
            }, null, 8, ["survey", "showModal"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ConfirmShareableChangeModal, {
          showModal: _ctx.showShareableChangeModal,
          "onUpdate:showModal": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showShareableChangeModal) = $event)),
          survey: _ctx.surveyRef
        }, null, 8, ["showModal", "survey"]),
        _createVNode(_component_ConfirmHideContactsChangeModal, {
          showModal: _ctx.showHideContactsChangeModal,
          "onUpdate:showModal": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showHideContactsChangeModal) = $event)),
          survey: _ctx.surveyRef
        }, null, 8, ["showModal", "survey"])
      ]))
    : _createCommentVNode("", true)
}